import { formatDateTime } from "@/utils/date.js";
import { TASK_RESULT_TYPES } from "@/utils/const.js";

const setTaskType = (taskName) => {
  if (taskName?.includes("generate_report_task")) {
    return TASK_RESULT_TYPES.REPORT_GENERATION;
  }
  return TASK_RESULT_TYPES.OTHER;
};

const formatToJson = (value) => {
  const newValue = JSON.parse(value);

  if (typeof newValue !== "string") {
    return newValue;
  }

  const jsonString = newValue
    .replace(/'/g, '"')
    .replace(/True/g, "true")
    .replace(/False/g, "false")
    .replace(/None/g, "null");

  return JSON.parse(jsonString);
};

export const formatTaskResult = (taskResult) => {
  let auditUuid = null;
  let formattedKwargs = {};

  if (taskResult.taskKwargs) {
    try {
      const kwargs = formatToJson(taskResult.taskKwargs);
      auditUuid = kwargs.audit_uuid || null;
      formattedKwargs = kwargs;
    } catch (error) {
      console.error("Error parsing taskKwargs:", error);
    }
  }
  if (taskResult.result) {
    try {
      taskResult.result = formatToJson(taskResult.result);
    } catch (error) {
      console.error("Error parsing task result:", error);
    }
  }

  return {
    ...taskResult,
    auditUuid,
    dateCreated: formatDateTime(taskResult.dateCreated),
    dateDone: formatDateTime(taskResult.dateDone),
    formattedKwargs,
    ...(taskResult.taskName && { taskType: setTaskType(taskResult.taskName) }),
  };
};
